// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sidebar-contact-blocked[data-v-683cd8b2] {\n\tmargin: 4px 12px 6px 12px;\n\tpadding: 6px 10px;\n\tborder-radius: 4px;\n\tbackground: rgba(196, 80, 58, 0.1);\n\tcolor: rgba(196, 80, 58, 1);\n\tfont-size: 12px;\n\tfont-weight: 600;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
